import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { TextStyle } from '../../../DesignSystem/Feedback/TextStyle';
import { Button } from '../../../DesignSystem/Inputs/Button';

type EmptyStateCardProps = {
  title: string;
  description: string | ReactNode;
  image: string | ReactNode;
  imageBackgroundClass?: string;
  imageClassName?: string;
  ctaText?: string;
  onCtaClick?: () => void;
  buttonIcon?: ReactNode;
};
export const EmptyStateCard = (props: EmptyStateCardProps) => {
  const {
    title,
    description,
    image,
    imageBackgroundClass = '',
    imageClassName,
    ctaText,
    onCtaClick,
    buttonIcon,
  } = props;
  return (
    <div
      className="flex w-full flex-col items-center gap-6 self-stretch rounded-md border-2 border-dashed border-gray-5 bg-gray-1 bg-opacity-50 p-6 sm:flex-row"
      data-testid="empty-state-card-container"
    >
      <div>
        {typeof image === 'string' || typeof image == 'undefined' ? (
          <div className={twMerge('rounded-lg', imageBackgroundClass)}>
            <img
              src={image}
              className={twMerge('m-auto', imageClassName)}
              alt="empty state"
            />
          </div>
        ) : (
          image
        )}
      </div>
      <div className="flex flex-col items-center gap-1 sm:items-start">
        <TextStyle variant="base-bold" data-testid="empty-state-title">
          {title}
        </TextStyle>
        <TextStyle
          variant="sm-regular"
          subdued={true}
          data-testid="empty-state-description"
        >
          {description}
        </TextStyle>
        {Boolean(ctaText && onCtaClick) && (
          <Button
            title={ctaText}
            variation="primary"
            onClick={onCtaClick}
            size="small"
            data-testid="empty-state-cta"
          >
            {buttonIcon}
            {ctaText}
          </Button>
        )}
      </div>
    </div>
  );
};
